var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgFilter = function SvgFilter(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.46863 4.46863C4.76869 4.16857 5.17565 4 5.6 4H18.4C18.8243 4 19.2313 4.16857 19.5314 4.46863C19.8314 4.76869 20 5.17565 20 5.6V7.66879C19.9999 8.09306 19.8313 8.5001 19.5313 8.80008C19.5313 8.80011 19.5313 8.80005 19.5313 8.80008L14.4001 13.9313L14.4 16C14.4 16.2122 14.3157 16.4156 14.1657 16.5657L10.9657 19.7657C10.7369 19.9945 10.3928 20.0629 10.0939 19.9391C9.79491 19.8153 9.6 19.5235 9.6 19.2V13.9314L4.4688 8.80016C4.46877 8.80014 4.46883 8.80019 4.4688 8.80016C4.16877 8.50018 4.00009 8.09324 4 7.66897V5.6C4 5.17565 4.16857 4.76869 4.46863 4.46863ZM18.4 5.6H5.6V7.66862L10.7312 12.7998C10.7312 12.7998 10.7312 12.7998 10.7312 12.7998C11.0312 13.0998 11.1999 13.5067 11.2 13.931V17.2686L12.8 15.6686V13.9312C12.8001 13.5069 12.9687 13.0999 13.2687 12.7999C13.2687 12.7999 13.2687 12.7999 13.2687 12.7999L18.3999 7.66871L18.4 5.6Z",
    fill: "#64748B"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgFilter, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/filter.9be70601.svg";
export { ForwardRef as ReactComponent };